<template>
  <div id="RememberPasswordHampa" class="remember-password-page">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      title="بازیابی رمز عبور"
      description="برای دریافت پیامک بازیابی، کد ملی و شماره موبایل ثبت‌شده در سیستم را وارد کنید"
      :show-back="true"
      wrap-class="netpa-list-page-card-wrap--inset netpa-list-page-card-wrap--centered no-print"
    >
      <div class="remember-password-content py-3 px-2">
        <form id="div1" class="remember-password-form">
          <div class="remember-password-field">
            <input
              class="form-control text-center required-CodeMeli"
              dir="ltr"
              type="number"
              v-model="Codemeli"
              placeholder="کد ملی"
            />
          </div>
          <div class="remember-password-field">
            <input
              class="form-control text-center required"
              dir="ltr"
              type="number"
              v-model="mobile"
              placeholder="شماره موبایل"
            />
          </div>
          <div class="remember-password-actions">
            <button
              type="button"
              class="btn btn-success remember-password-submit-btn"
              @click.prevent="sendSms"
            >
              ارسال پیامک بازیابی
            </button>
          </div>
        </form>
      </div>
    </net-pa-list-page-card>
  </div>
</template>

<script>
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import loading from "../Tools/NetPa/Loading.vue";

export default {
  components: { NetPaListPageCard, loading },
  data() {
    return {
      mobile: "",
      Codemeli: "",
      stage: 1,
      validation: false,
      NewPassRepeat: "",
      newPass: "",
      yekbarRamz: "",
      loadingRender: false,
    };
  },
  methods: {
    sendSms() {
      if (this.$ValidForm("div1")) {
        if (this.Codemeli == "") {
          this.$mySweetDefaultTost(
            "خطا",
            " کد ملی نمیتواند خالی باشد.",
            "error",
            2000,
          );
        }
        if (this.mobile == "") {
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه نمیتواند خالی باشد.",
            "error",
            2000,
          );
        } else {
          this.loadingRender = true;
          var DataAxiosForget = {
            ArryfildValue: {},
            Action: "Bazyabi/RememberPassHampa",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append("mobile", this.mobile);
          formData.append("codeMeli", this.Codemeli);
          DataAxiosForget.ArryfildValue = formData;
          this.$PostFormData(DataAxiosForget).then((data) => {
            if (data.status == "Ok") {
              this.mobile = "";
              this.codeMeli = "";
              this.$mySweetDefaultTost("موفق", data.msg, data.icone, 3000);
              this.loadingRender = false;
            } else {
              this.loadingRender = false;
              this.$mySweetDefaultTost("خطا", data.msg, data.icone, 5000);
            }
          });
        }
      }
    },
    changepass() {
      this.loadingRender = true;
      if (this.newPass == this.NewPassRepeat) {
        var DataAxiosChangePass = {
          ArryfildValue: {},
          Action: "Bazyabi/UpdatePass",
          Method: "POST",
          Token: "",
        };
        const formData = new FormData();
        formData.append(
          "AxarinTaghirPass",
          this.$store.state.JalaliDateAndTime,
        );
        formData.append("newPass", this.newPass);
        formData.append("randomKey", this.yekbarRamz);
        formData.append("codeMeli", this.Codemeli);
        DataAxiosChangePass.ArryfildValue = formData;
        this.$PostFormData(DataAxiosChangePass).then((data) => {
          this.$mySweetDefaultTost(" ", data.msg, data.icone, 2000);
          if (data.status == "Ok") {
            this.$router.go(-1);
          } else {
            this.loadingRender = false;
            this.stage = 2;
          }
        });
      } else {
        this.$mySweetDefaultTost(
          " خطا",
          "رمز عبور وارد شده و تکرارش برابر نیستند!",
          "error",
          2000,
        );
      }
    },
  },
  mounted() {
    this.NewPassRepeat = "";
    this.newPass = "";
    this.yekbarRamz = "";
  },
};
</script>

<style scoped>
.remember-password-content {
  width: 100%;
}

.remember-password-form {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  direction: rtl;
}

.remember-password-field {
  margin-bottom: 0.75rem;
}

.remember-password-actions {
  margin-top: 1rem;
}

.remember-password-submit-btn {
  width: 100%;
  min-height: 40px;
  border-radius: 8px;
  font-weight: 600;
}
</style>
